import lib from "./lib";
import { VueConstructor } from "vue";

declare module "vue/types/vue" {
  interface Vue {
    $ga: {
      pageview: () => void;
      page: (path: string) => void;
      bucket: (bucket: string) => void;
      button: (title: string) => void;
      toggle: (title: string) => void;
      checkbox: (label: string, checked: boolean) => void;
    };
  }
}

export default function install(Vue: VueConstructor) {
  Vue.prototype.$ga = lib;
}
